import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import { NavBadgeProvider, useNavBadgeContext } from '../context/NavBadgeContext';

function AdminLayoutInner() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { badges } = useNavBadgeContext();

  function toggleSidebar() {
    setSidebarOpen((p) => !p);
  }

  return (
    <>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} badges={badges} />
      <TopNav onToggleSidebar={toggleSidebar} />
      <main id="main">
        <div className="content">
          <Outlet />
        </div>
      </main>
    </>
  );
}

export default function AdminLayout() {
  return (
    <NavBadgeProvider>
      <AdminLayoutInner />
    </NavBadgeProvider>
  );
}
